import React, { Component, Fragment } from 'react';

import DEFINE, { TRANSLATE_LANGUAGE } from '../../../../../../../../constants/Define';
import { TagSKUVWTYPE } from '../../../../../../../../models/Tour';

import {
    FormWrapperInputComponent,
} from "../../../../../../common/component/Index";
import AntSelect, { AntOption } from '../../../../../../common/component/AntSelect';
import Wrapper from '../../../../../../common/component/Wrapper';
import Ripple from '../../../../../../common/component/Ripple';
import Modal from '../../../../../../common/component/Modal';
import Input from '../../../../../../common/component/Input';

import { Divider, Icon } from 'antd';

import './TagSKUVWStyle.less';
import Span from '../../../../../../common/component/Span';
import Images from 'constants/Images';

export default class TagSKUVW extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isShowAddModal: false,
            editTagSKUVW: {
                id: undefined,
                name: undefined,
                details: [],
            },
        };
    }

    render() {
        const { t, tags, selections, loading } = this.props;
        return (
            <Fragment>
                <AntSelect className="select-tag-sku-vw tourTypes"
                    showArrow loading={loading}
                    mode="multiple"
                    placeholder={t(`item.tour.selectTagSKUVW`)}
                    value={selections.map(item => item.id)}
                    onChange={this.props.onChange}
                    style={{ width: '100%' }}
                    filterOption={this.props.filterOption}
                    dropdownRender={this.renderMenuOption}
                    open={this.state.isOpen}
                    onDropdownVisibleChange={(isOpen) => this.setState({ isOpen })}
                >
                    {(tags || []).map(type => (
                        <AntOption key={type.id} value={type.id}>
                            <Span className="select-tag-sku-vw-item">
                                {type.name}
                                <Span className="button-section">
                                    <Wrapper
                                        className="btn-edit"
                                        onMouseDown={e => e.preventDefault()}
                                        onClick={e => { e.preventDefault(); this.onEditItem(e, type) }} >
                                        <Icon type="edit" />
                                    </Wrapper>
                                    <Wrapper
                                        className="btn-edit"
                                        onMouseDown={e => e.preventDefault()}
                                        onClick={e => { e.preventDefault(); this.onDeleteItem(e, type) }} >
                                        <Icon type="delete" />
                                    </Wrapper>
                                </Span>
                            </Span>
                        </AntOption>
                    ))}
                </AntSelect>
                {this.renderAddTagSKUVWModal()}
            </Fragment>
        )
    }

    renderMenuOption = (menu) => {
        const { t } = this.props;

        return (
            <Wrapper className="select-tag-sku-vw-dropdown">
                {menu}
                <Divider style={{ margin: '4px 0' }} />
                <Wrapper
                    style={{ padding: '0px 8px 4px 8px', cursor: 'pointer', width: '100%' }}
                    onMouseDown={e => e.preventDefault()}
                    onClick={this.onAddItem}
                >
                    <Icon type="plus" /> {t(`action.create`)}
                </Wrapper>
            </Wrapper>
        )
    }

    renderAddTagSKUVWModal = () => {
        const { t } = this.props;
        const { editTagSKUVW, isShowAddModal,  } = this.state;
        return (
            <Modal
                visible={isShowAddModal}
                title={`${editTagSKUVW && editTagSKUVW.id ? t('action.update') : t('action.create')} ${t('item.tour.tagSKUVW')}`}
                okText={editTagSKUVW && editTagSKUVW.id ? t('action.update') : t('action.create')} cancelText={t('action.cancel')}
                okButtonProps={{ disabled: !editTagSKUVW || !(editTagSKUVW.details || []).find(item => item.languageCode === TRANSLATE_LANGUAGE.VN.code)?.name }}
                onOk={editTagSKUVW && editTagSKUVW.id ? this.editTagSKUVW : this.addTagSKUVW}
                onCancel={() => this.setState({ isShowAddModal: false, editTagSKUVW: new TagSKUVWTYPE() })}
            >
                <div className="" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                    <Input value={editTagSKUVW && ((editTagSKUVW.details || []).find(item => item.languageCode === TRANSLATE_LANGUAGE.VN.code)?.name || "")}
                        autoFocus
                        placeholder={t('item.tour.tagSKUVWName')}
                        onChange={e => {
                            this.onChangeName(e.target.value, TRANSLATE_LANGUAGE.VN.code);
                        }}
                        addonBefore={<img src={Images.flag.square['vi']} className="flag-icon-16px mr-1" />}
                    />
                    <Input value={editTagSKUVW && ((editTagSKUVW.details || []).find(item => item.languageCode === TRANSLATE_LANGUAGE.EN.code)?.name || "")}
                        autoFocus
                        placeholder={t('item.tour.tagSKUVWName')}
                        onChange={e => {
                            this.onChangeName(e.target.value, TRANSLATE_LANGUAGE.EN.code);
                        }}
                        addonBefore={<img src={Images.flag.square['en']} className="flag-icon-16px mr-1" />}
                    />
                    <Input value={editTagSKUVW && ((editTagSKUVW.details || []).find(item => item.languageCode === TRANSLATE_LANGUAGE.ZH.code)?.name || "")}
                        autoFocus
                        placeholder={t('item.tour.tagSKUVWName')}
                        onChange={e => {
                           this.onChangeName(e.target.value, TRANSLATE_LANGUAGE.ZH.code);
                        }}
                        addonBefore={<img src={Images.flag.square['zh']} className="flag-icon-16px mr-1" />}
                    />
                    <Input value={editTagSKUVW && ((editTagSKUVW.details || []).find(item => item.languageCode === TRANSLATE_LANGUAGE.KO.code)?.name || "")}
                        autoFocus
                        placeholder={t('item.tour.tagSKUVWName')}
                        onChange={e => {
                            this.onChangeName(e.target.value, TRANSLATE_LANGUAGE.KO.code);
                         }}
                        addonBefore={<img src={Images.flag.square['ko']} className="flag-icon-16px mr-1" />}
                    />
                </div>
            </Modal>
        )
    }

    onChangeName = (value, langCode) => {
        const { editTagSKUVW } = this.state;
        const details = [...(editTagSKUVW.details || [])];
        const detail = details.find(item => item.languageCode === langCode);
        if (detail) {
            detail.name = value;
        } else {
            details.push({ languageCode: langCode, name: value });
        }
        this.setState({ editTagSKUVW: { ...editTagSKUVW, details } });
    }


    onAddItem = (e) => {
        e.stopPropagation();
        this.setState({ isShowAddModal: true, editTagSKUVW: new TagSKUVWTYPE() })
    }

    addTagSKUVW = () => {
        const { editTagSKUVW } = this.state;
        this.props.onCreate(editTagSKUVW);
        this.setState({ isShowAddModal: false, isOpen: true })
    }

    onEditItem = (e, tagSKUVW) => {
        e.stopPropagation();
        this.setState({ isShowAddModal: true, editTagSKUVW: tagSKUVW })
    }

    editTagSKUVW = () => {
        const { editTagSKUVW } = this.state;
        this.props.onUpdate(editTagSKUVW);
        this.setState({ isShowAddModal: false, isOpen: true });
    }

    onDeleteItem = (e, tagSKUVW) => {
        const { t, selections } = this.props;
        const { confirm } = Modal;
        this.setState({ isOpen: false });
        e.stopPropagation();
        confirm({
            title: t(`notification.sureRemove`),
            content: `"${tagSKUVW.name}"`,
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                this.props.onChange(selections.filter(item => item.id !== tagSKUVW.id).map(item => item.id));
                this.props.onDelete(tagSKUVW);
                this.setState({ isOpen: true });
            },
        });
    }

}

TagSKUVW.defaultProps = {
    onChange: (ids) => { },
    filterOption: (input, option) => { },
    onCreate: tagSKUVW => { },
    onUpdate: tagSKUVW => { },
    onDelete: tagSKUVW => { },
    selections: [],
    tagSKUVW: [],
    loading: false,
}

